/* eslint-disable jsx-a11y/label-has-associated-control */

import React from "react";
import { formatTime } from "../../../../../../../../../Utils";
import { useContext } from "../../../context";

export function Time() {
  const { appointment } = useContext();

  return (
    <div className="detail-row">
      <label>Time:</label>
      <span>
        {formatTime(appointment.outOfOffice.startTime)} -{" "}
        {formatTime(appointment.outOfOffice.endTime)}
      </span>
    </div>
  );
}
